"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var padStart = function padStart(str, len, chars) {
  if (str === void 0) {
    str = '';
  }

  if (len === void 0) {
    len = 0;
  }

  if (chars === void 0) {
    chars = ' ';
  }

  var strValue = String(str);
  var charsValue = String(chars);
  var prefix = '';
  var strLen = strValue.length;
  var prefixLen = len - strLen;

  while (prefix.length < prefixLen) {
    prefix += charsValue;
  }

  prefix = prefix.slice(0, prefixLen);
  return prefix + strValue;
};

var _default = padStart;
exports["default"] = _default;
module.exports = exports.default;